import { useApi } from "./api";

export interface OverviewStats {
  total_workers: number;
  active_workers: number;
  completed: number;
  errors: number;
  total: number;
  data: Array<{
    date: string;
    completed: number;
    errors: number;
    total: number;
  }>;
}

export function useOverviewService() {
  const api = useApi();

  return {
    /**
     * Get overview statistics
     */
    async getStats(): Promise<OverviewStats> {
      return api.get<OverviewStats>("/bff/overview/stats");
    },
  };
}
